/*eslint-disable*/
export const MAX_ALLOWED_MEMBERS = 5